import React, {Component} from "react";
import styled from "styled-components";
import {Clock} from "react-feather";

import sangImg from "../Images/todo.png";
import {
  LargeTitle,
  InfoParagraph,
  SmallMargin,
  lightest,
  Contain,
  MediumTitle,
  gray,
  SmallTitle,
  ReadMore,
  ContainWPadding
} from "../Tools/Variables";

const Wrapper = styled.div `
  position: relative;
  width: 100%;
  padding: 40px 0;
  background-size: cover;
  background-position: bottom;
`;

const Overlay = styled.div `
  transition: 0.5s ease-in-out;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background: white;
  opacity: 1;
`;

const TextWrapper = styled.div `
  color: black;
  flex: 0 1 auto;
  max-width: 500px;
`;

const FlexContainer = styled.div `
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

class Sustainability2 extends Component {
  render() {
    return (
      <Wrapper>
        <Overlay/>
        <div style={{
          position: "relative"
        }}>
          <ContainWPadding>
            <FlexContainer>
              <div
                style={{
                flex: "0 1 auto",
                display: "flex",
                position: "relative",
                height: "auto",
                maxWidth: "400px",
                alignSelf: "flex-start"
              }}>
                <img
                  src={sangImg}
                  style={{
                  flex: "0 1 auto",
                  height: "100%",
                  width: "100%",
                  maxWidth: "400px",
                  opacity: "0.7"
                }}
                  alt={"Modilect - sängen för framtiden"}/>
              </div>

              <TextWrapper>
                <SmallTitle>Framtidssäkrad sömn</SmallTitle>
                <SmallMargin/>
                <LargeTitle>
                  Världens bästa säng. Varje dag. Hela livet.
                </LargeTitle>
                <SmallMargin/>
                <InfoParagraph
                  style={{
                  maxWidth: 400,
                  color: "inherit"
                }}>
                  Din Modilectsäng är en investering som du aldrig kommer ångra. Istället för att
                  tvingas byta säng ca var tionde år är vår premiumsäng en trogen familjemedlem hela
                  livet ut. Den kommer inte tappa sin komfort eller fasthet med åren, utan
                  utvecklas hela tiden med sin ägare.
                  <SmallMargin/> {/*
                    <ReadMore> </ReadMore>
                    */}
                </InfoParagraph>
              </TextWrapper>
            </FlexContainer>
          </ContainWPadding>
        </div>
      </Wrapper>
    );
  }
}

export default Sustainability2;



// WEBPACK FOOTER //
// ./src/Home/Sustainability2.js